<template>

    <div class="uploader" :style="{ display: uploaderWidth === '100%' ? 'block' : 'inline-block' }">
        <div class="uploader-body" :style="styles">
            <v-button-toolbar v-if="!loading && image && removeable" class="uploader-toolbar">
                <v-button-icon v-if="!(uploaderWidth < 300)" icon="fas fa-cloud-upload-alt" width="30px" height="30px" @click.native="selectPhoto" v-tooltip="{ 'content': $t('labels.upload') }" />
                <v-button-icon icon="fas fa-xmark" width="30px" height="30px" @click.native="removePhoto" v-tooltip="{ 'content': $t('labels.remove') }" />
            </v-button-toolbar>
            <input :id="uploaderId" type="file" name="file" @change="uploadPhoto" />
            <div v-if="loading || !image" class="uploader-loader" :class="{ loading: loading }" @click="selectPhoto">
                <v-loader v-if="loading" />
                <i v-else class="fas fa-plus" />
            </div>
            <div class="image" v-if="image" :style="{ 'background-image': `url(${image})` }" @click="_openLink(image, '_blank')"></div>
        </div>
    </div>

</template>

<style scoped lang="scss">

    .uploader {

        background: $color-white;
        border: 1px solid $color-rule;
        border-radius: 3px;
        display: inline-block;
        padding: 5px;
        transition: border-color .3s;
        &:hover {
            border-color: $color-text;
        }

        .uploader-loader {
            align-items: center;
            background: $color-bg;
            color: $color-text;
            display: flex;
            font-size: 20px;
            height: 100%;
            justify-content: center;
            position: absolute;
            width: 100%;
            z-index: 1;
            &.loading {
                background: rgb(from $color-white r g b / 90%);
            }
            i {
                color: $color-text;
            }
        }

        .uploader-toolbar {
            padding: 5px;
            position: absolute;
            right: 0;
            top: 0;
            z-index: 3;
        }

        .uploader-body {
            cursor: pointer;
            overflow: hidden;
            position: relative;
            input[type=file] {
                background: transparent;
                height: 1px;
                left: 0;
                margin: 0;
                opacity: 0;
                padding: 0;
                pointer-events: none;
                position: absolute;
                top: 0;
                width: 1px;
                z-index: 2;
            }
            .image {
                background-position: center;
                background-repeat: no-repeat;
                background-size: contain;
                border-radius: 3px;
                height: 100%;
                width: 100%;
            }
        }

    }

</style>

<script>

import BaseApi from '@api/BaseApi';

export default {

    props: {
        uploaderId: {
            type: String,
            default: 'file',
        },
        uploaderWidth: {
            type: [Number, String],
            default: 250,
        },
        uploaderHeight: {
            type: Number,
            default: 250,
        },
        uploaderImage: {
            type: String,
        },
        uploaderUrl: {
            type: String,
        },
        removeable: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            loading: false,
            image: this.uploaderImage,
        }
    },

    computed: {

        styles() {
            return {
                'height': typeof this.uploaderHeight === 'number' ? this.uploaderHeight + 'px' : this.uploaderHeight,
                'width': typeof this.uploaderWidth === 'number' ? this.uploaderWidth + 'px' : this.uploaderWidth,
            }
        },

    },

    methods: {

        selectPhoto() {
            document.getElementById(this.uploaderId).click();
        },

        uploadPhoto() {
            let file = document.getElementById(this.uploaderId).files[0];
            if (file) {
                this.loading = true;
                let params = new FormData();
                params.append('file', file);
                BaseApi.post(this.uploaderUrl, params)
                    .then((response) => {
                        this.loading = false;
                        this.image = response.data.data.link;
                        this.$store.commit('setAlertSuccess', this.$t('messages.saved'));
                        this.$emit('saved');
                    }, (error) => {
                        this.loading = false;
                        this.$store.commit('setAlertWithError', error);
                    });
            }
        },

        removePhoto() {
            this.loading = true;
            this.error = null;
            BaseApi.delete(this.uploaderUrl)
                .then((response) => {
                    this.loading = false;
                    this.image = null;
                    this.$store.commit('setAlertSuccess', this.$t('messages.deleted'));
                    this.$emit('saved');
                }, (error) => {
                    this.loading = false;
                    this.$store.commit('setAlertWithError', error);
                });
        },

    }

}

</script>
